import { CONFIRMATION_STEP_ROUTE } from './../../../word-exam-registration/confirmation-step/_const/confirmation-step-route.const';
import { WORD_EXAM_ROUTE } from 'src/app/applications/word-exam-registration/_consts/word-exam-route.const';
import { WordConfirmationService } from './word-confirmation.service';
import { WordPaymentConfirmationDto } from './../_models/word-payment-confirmation.model';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take, catchError, switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/core/auth';

@Injectable({
  providedIn: 'root'
})
export class WordPaymentConfirmationGuard  {
  constructor(
    private router: Router,
    private wordPaymentConfirmation: WordConfirmationService,
    private auth: AuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.auth.user$
      .pipe(
        take(1),
        map((result) => {
          if (result == null) {
            this.auth.login(state.url);
            return false;
          }
        }),
        switchMap(() =>
          this.wordPaymentConfirmation.getPaymentSummary$(route.paramMap.get('billid'))
        )
      )
      .pipe(
        take(1),
        map((result: WordPaymentConfirmationDto) => {
          this.router.navigate([
            '/',
            WORD_EXAM_ROUTE,
            CONFIRMATION_STEP_ROUTE,
            result.reservationId
          ]);
          return false;
        })
      );
  }
}
